import React from 'react'
import { Card } from 'antd';

const SalesReturnReportFooter = ({ locationId }) => {

  console.log("exist", locationId)
  return (
    <div className='order_report_footer'

    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Card style={{ width: "475px" }}>
          <p className='footer_order_p' style={{ display: "flex", justifyContent: "center", textDecoration: "underline" }}>Return Instructions</p>
          <p className='footer_order_p'>1) No return will be accepted without RA#.</p>
          <p className='footer_order_p'>2) All Return must include a copy of this packing list.</p>
          <p className='footer_order_p'>3) Only approved styles and Quantities are returnable against this RA.</p>
          <p className='footer_order_p'>4) Returns will not be accepted if merchandise has a sensor on it.</p>
          <p className='footer_order_p'>5) Return will not be accepted after expire date.</p>
          <p className='footer_order_p'>6) Only Credit Memo will be issued for returned goods - no refund.</p>
          <p className='footer_order_p'>7) There will be a deduction of 5% if the returned unit is missing waist tag.</p>
          <p className='footer_order_p'>8) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.</p>
        </Card>
        {
          locationId === 3 ?
            <Card style={{ width: "310px" }}>
              <p className='footer_order_p' style={{ display: "flex", justifyContent: "center", textDecoration: "underline" }}>Return Address</p>
              <p className='footer_order_p'>DL1961 Showroom<br />
                121 Varick St, 4th Floor<br />
                New York, NY 10013 <br />
                Tel: 646.514.9736</p>
            </Card>
            :
            <Card style={{ width: "310px" }}>
              <p className='footer_order_p' style={{ display: "flex", justifyContent: "center", textDecoration: "underline" }}>Return Address</p>
              <p className='footer_order_p'>DL1961 Premium Denim c/o Bergen Logistics <br />
                299 Thomas E. Dunn Memorial Highway<br />
                Rutherford, NJ 07070 <br />
                Contact Person: Karla Hernandez <br />
                Tel: 201 624 2170 Ext.231  <br />
                Tel: 201 854 8136</p>
            </Card>
        }
      </div>

    </div>
  )
}

export default SalesReturnReportFooter;